export default {
    props: {
      data: Array
    },
    created() {
      this.form = this.data[0];
      this.onInput(this.form);
    },
    methods: {
      onInput(val) {
        this.$bus.$emit("input", val);
      }
    },
    // watch: {
    //   data: {
    //     immediate: true,
    //     deep: true,
    //     handler(value) {
    //       this.form = value;
    //     }
    //   }
    // }
  };
  